import React from "react";
import { Mail, LogOut, Award } from "lucide-react";
import usePartnerAwareNavigate from "src/hooks/usePartnerAwareNavigate";

interface UserDropdownProps {
  accountName: string;
  email: string;
  subscriptionLevel?: string;
  onSignOut: () => void;
}

const userIconSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-3.31 0-10 1.67-10 5v2h20v-2c0-3.33-6.69-5-10-5z"
      fill="var(--color-primary)"
    />
  </svg>
);

export const UserDropdown: React.FC<UserDropdownProps> = ({
  accountName,
  email,
  onSignOut,
  subscriptionLevel = "free",
}) => {
  const navigate = usePartnerAwareNavigate();

  const handleSubscriptionClick = () => {
    navigate("/subscription");
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-lg w-80 p-4">
      {/* User Profile Section */}
      <div className="mb-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {userIconSVG}
            <span className="text-gray-900">{accountName}</span>
          </div>
          <button className="p-1 bg-[#F5F6F7] hover:bg-gray-100 rounded">
            {/* <Edit2 size={16} className="text-gray-500 " /> */}
          </button>
        </div>
      </div>

      {/* Divider */}
      <div className="h-[1px] bg-gray-200 mb-4" />

      {/* Email and Sign Out Section */}
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-start space-x-3">
            <Mail className="text-gray-500 mt-1" size={20} />
            <div>
              <div className="text-gray-900 mb-1">Email</div>
              <div className="text-gray-600">{email}</div>
            </div>
          </div>
        </div>
        <button
          onClick={handleSubscriptionClick}
          className="flex items-center justify-between w-full hover:bg-gray-100 rounded py-2 transition-colors duration-200"
        >
          <div className="flex items-start space-x-3">
            <Award className="text-gray-500 mt-1" size={20} />
            <div className="text-left">
              <div className="text-gray-900 mb-1">Subscription</div>
              <div className="text-gray-600">{subscriptionLevel}</div>
            </div>
          </div>
        </button>
        <button
          onClick={onSignOut}
          className="flex items-center space-x-3 text-gray-700 hover:bg-gray-100 w-full py-2 px-0 rounded transition-colors duration-200"
        >
          <LogOut size={20} className="text-gray-500" />
          <span>Sign out</span>
        </button>
      </div>
    </div>
  );
};

export default UserDropdown;
